export default {
    LOAD_ENTRANCE_EXIT(state, entrance_exit) {
        state.items = entrance_exit;
    }
}
